import styled from '@emotion/styled';

const UserListWrapper = styled('section')({
  marginBottom: 18,
});

export default UserListWrapper;
